var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.287 6.29535C11.6808 5.90155 12.3192 5.90155 12.713 6.29535L23.7342 17.3165C24.0886 17.6709 24.0886 18.2455 23.7342 18.6C23.3798 18.9544 22.8051 18.9544 22.4507 18.6L12 8.14928L1.54931 18.6C1.19488 18.9544 0.620245 18.9544 0.265819 18.6C-0.0886064 18.2455 -0.0886064 17.6709 0.265819 17.3165L11.287 6.29535Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBlue);
export default __webpack_public_path__ + "static/media/arrowUpBlue.92c76924957f998085a06ae7e38f50b1.svg";
export { ForwardRef as ReactComponent };